import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from "../../nest-api";

@Injectable()
export class EmploymentInfoSf6Api {

  private readonly service: string = '';
  private readonly model: string = 'sf6s';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public detail(empId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'employmentInfo/detail';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/employment-info-sf6.api.ts